import {
  BaseOrganizationResponse,
  OrganizationResponse,
} from "@/redux/organizations/types";
import { Roles } from "@/shared/utils/constants";
import { FullUserResponse } from "@/redux/users/types";

export const hasExternalId = (
  org: BaseOrganizationResponse | OrganizationResponse,
): org is OrganizationResponse => {
  return "externalId" in org && org.externalId !== undefined;
};

export const isFullOrganizationResponse = (
  organization: BaseOrganizationResponse | OrganizationResponse,
  currentUser: FullUserResponse,
): organization is OrganizationResponse => {
  return (
    currentUser.role === Roles.ADMIN.value ||
    currentUser.organization?.id === organization.id
  );
};
